import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MUTATION_KEYS } from './keysAndEndpoints';
import {
  saveInfo,
  saveResponse,
  sendVerificationCode,
  verifyGuestOTP,
} from './services';
import {
  SaveInfoParams,
  SendVerificationCodeParams,
  VerifyGuestOTPParams,
} from '../types/api';
import { SaveResponsePayload } from 'pages/Forms/types/submission';

export const useSendVerificationCodeMutation = (
  options?: UseMutationOptions<
    AxiosResponse,
    AxiosError,
    SendVerificationCodeParams
  >,
) =>
  useMutation({
    mutationFn: sendVerificationCode,
    mutationKey: [MUTATION_KEYS.SEND_GUEST_OTP],
    ...options,
  });

export const useVerifyGuestOTPMutation = (
  options?: UseMutationOptions<AxiosResponse, AxiosError, VerifyGuestOTPParams>,
) =>
  useMutation({
    mutationFn: verifyGuestOTP,
    mutationKey: [MUTATION_KEYS.VERIFY_GUEST_OTP],
    ...options,
  });

export const useSaveInfoMutation = (
  options?: UseMutationOptions<AxiosResponse, AxiosError, SaveInfoParams>,
) =>
  useMutation({
    mutationFn: saveInfo,
    mutationKey: [MUTATION_KEYS.SAVE_INFO],
    ...options,
  });

export const useSaveResponseMutation = (
  options?: UseMutationOptions<AxiosResponse, AxiosError, SaveResponsePayload>,
) =>
  useMutation({
    mutationFn: saveResponse,
    mutationKey: [MUTATION_KEYS.SAVE_RESPONSE],
    ...options,
  });
